"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCommonMessageFields = void 0;
var buildVariation = function (wattpad) {
    var testGroups = wattpad === null || wattpad === void 0 ? void 0 : wattpad.testGroups;
    var isWpWeb = wattpad === null || wattpad === void 0 ? void 0 : wattpad.isWpWeb;
    var variations = [];
    if (testGroups.DELAY_ADS) {
        variations.push("image_moderation=true");
    }
    if (testGroups.PREBID_BETA) {
        variations.push("pb_beta=true");
    }
    if (testGroups.EXCLUDE_PREBID_PARTNERS) {
        variations.push("exclude_prebid_partners=true");
    }
    if (testGroups.USE_KEVEL) {
        variations.push("use_kevel=true");
    }
    if (testGroups.USE_33ACROSS) {
        variations.push("use_33across=true");
    }
    if (testGroups.USE_IMAGE_MOD) {
        variations.push("use_image_mod=true");
    }
    if (isWpWeb) {
        variations.push("wpweb=true");
    }
    return variations.join("&");
};
// this creates the event_id for this event as well, and returns it as a part
// of the message. All our ads are associated with a story, and possibly a part
var getCommonMessageFields = function (page, storyId, partId, storyGroup, storyPart) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var device = (_a = window === null || window === void 0 ? void 0 : window.wattpad) === null || _a === void 0 ? void 0 : _a.deviceType;
    var eventId = generateUUID();
    var isGdprUser = !!((_b = window === null || window === void 0 ? void 0 : window.wattpad) === null || _b === void 0 ? void 0 : _b.testGroups.isGdprUser);
    // data common to all atha messages
    var message = {
        app_version: (_c = window === null || window === void 0 ? void 0 : window.wattpad) === null || _c === void 0 ? void 0 : _c.revision,
        brand_safety_level: (_d = window === null || window === void 0 ? void 0 : window.ads) === null || _d === void 0 ? void 0 : _d.brand_safety_level,
        brand_safety_source: (_e = window === null || window === void 0 ? void 0 : window.ads) === null || _e === void 0 ? void 0 : _e.brand_safety_source,
        country_code: (_f = window === null || window === void 0 ? void 0 : window.wattpad) === null || _f === void 0 ? void 0 : _f.userCountryCode,
        created_at: new Date().toISOString(),
        external_id: (_h = (_g = window === null || window === void 0 ? void 0 : window.wattpad) === null || _g === void 0 ? void 0 : _g.currentUser) === null || _h === void 0 ? void 0 : _h.externalId,
        gdpr_is_eu: isGdprUser,
        id: eventId,
        is_brand_safe: (_j = window === null || window === void 0 ? void 0 : window.ads) === null || _j === void 0 ? void 0 : _j.is_brand_safe,
        is_mature: (_k = window === null || window === void 0 ? void 0 : window.ads) === null || _k === void 0 ? void 0 : _k.is_mature,
        page: page,
        platform: device === "mobile" ? "mobile-web" : "desktop-web",
        storyid: storyId,
        username: (_m = (_l = window === null || window === void 0 ? void 0 : window.wattpad) === null || _l === void 0 ? void 0 : _l.currentUser) === null || _m === void 0 ? void 0 : _m.username,
        variation: buildVariation(window === null || window === void 0 ? void 0 : window.wattpad),
    };
    if (storyGroup !== undefined) {
        message.is_brand_safe = !!(storyGroup === null || storyGroup === void 0 ? void 0 : storyGroup.isBrandSafe);
        message.is_mature = isMatureStory(storyGroup);
        message.brand_safety_source = storyGroup === null || storyGroup === void 0 ? void 0 : storyGroup.brandSafetySource;
        message.brand_safety_level = storyGroup === null || storyGroup === void 0 ? void 0 : storyGroup.brandSafetyLevel;
    }
    if (storyPart !== undefined) {
        message.brand_safety_source = storyPart === null || storyPart === void 0 ? void 0 : storyPart.brandSafetySource;
        message.brand_safety_level = storyPart === null || storyPart === void 0 ? void 0 : storyPart.brandSafetyLevel;
    }
    if (partId !== undefined) {
        message.partId = partId;
    }
    return message;
};
exports.getCommonMessageFields = getCommonMessageFields;
/**
 * Fast UUID generator, RFC4122 version 4 compliant.
 * @author Jeff Ward (jcward.com).
 * @license MIT license
 * @link http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
 **/
var generateUUID = function () {
    var lut = [];
    for (var i = 0; i < 256; i++) {
        lut[i] = (i < 16 ? "0" : "") + i.toString(16);
    }
    var d0 = (Math.random() * 0xffffffff) | 0;
    var d1 = (Math.random() * 0xffffffff) | 0;
    var d2 = (Math.random() * 0xffffffff) | 0;
    var d3 = (Math.random() * 0xffffffff) | 0;
    return (lut[d0 & 0xff] +
        lut[(d0 >> 8) & 0xff] +
        lut[(d0 >> 16) & 0xff] +
        lut[(d0 >> 24) & 0xff] +
        "-" +
        lut[d1 & 0xff] +
        lut[(d1 >> 8) & 0xff] +
        "-" +
        lut[((d1 >> 16) & 0x0f) | 0x40] +
        lut[(d1 >> 24) & 0xff] +
        "-" +
        lut[(d2 & 0x3f) | 0x80] +
        lut[(d2 >> 8) & 0xff] +
        "-" +
        lut[(d2 >> 16) & 0xff] +
        lut[(d2 >> 24) & 0xff] +
        lut[d3 & 0xff] +
        lut[(d3 >> 8) & 0xff] +
        lut[(d3 >> 16) & 0xff] +
        lut[(d3 >> 24) & 0xff]);
};
var isMatureStory = function (storyGroup) {
    if (!storyGroup) {
        return true;
    }
    return (storyGroup === null || storyGroup === void 0 ? void 0 : storyGroup.rating) >= 4;
};
